/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

const loadFonts = async () => {
    const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ 'webfontloader');

    webFontLoader.load({
        google: {
            families: ['Inter:100,300,400,500,600,700,900&display=swap'],
        },
    });
};

export default loadFonts;
